var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "handle-wrap"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.currnetCustomer))]), _c('div', {
    staticClass: "page"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalCounts) + "条")]), _c('Page', {
    attrs: {
      "total": _vm.totalCounts,
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCalcSalesCostAnalyze
    }
  })], 1)]), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l(_vm.salesCostAnalyze, function (item, index) {
    return _c('div', {
      key: item._id,
      staticClass: "card-item",
      attrs: {
        "value": item._id
      }
    }, [_c('Card', {
      staticStyle: {
        "width": "350px"
      }
    }, [_c('p', {
      staticClass: "card-title",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('span', {
      staticClass: "cacl-date"
    }, [_vm._v(_vm._s(_vm.dayjs(item.createdAt, "title")) + " 核算")]), _c('Button', {
      staticClass: "btn",
      attrs: {
        "data-clipboard-text": _vm.con
      },
      on: {
        "click": function ($event) {
          return _vm.copy(item);
        }
      }
    }, [_vm._v("复制数据")])], 1), _c('div', {
      staticClass: "card-info"
    }, [_c('div', {
      staticClass: "recipe-NoId row"
    }, [_c('div', {
      staticClass: "row-key"
    }, [_vm._v("配方编号")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v("#" + _vm._s(item.recipe.NoId))])]), _c('div', {
      staticClass: "recipe-createdAt row"
    }, [_c('div', {
      staticClass: "row-key"
    }, [_vm._v("配方时间")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v(" " + _vm._s(_vm.dayjs(item.recipe.createdAt, "recipe")) + " ")])]), _c('div', {
      staticClass: "recipe-created row"
    }, [_c('div', {
      staticClass: "row-key"
    }, [_vm._v("配方创建者")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v(" " + _vm._s(item.recipe.createdBy ? item.recipe.createdBy.name : "") + " ")])]), _c('div', {
      staticClass: "recipe-verify row"
    }, [_c('div', {
      staticClass: "row-key"
    }, [_vm._v("配方审核者")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v(" " + _vm._s(item.recipe.verifiedBy ? item.recipe.verifiedBy.name : "-") + " ")])])]), _c('Row', {
      staticClass: "table-heade"
    }, [_c('Col', {
      staticClass: "material-heade",
      attrs: {
        "span": "8"
      }
    }, [_vm._v("材料")]), _c('Col', {
      staticClass: "ratio-heade",
      attrs: {
        "span": "4"
      }
    }, [_vm._v("比例")]), _c('Col', {
      staticClass: "unitCost-heade",
      attrs: {
        "span": "4"
      }
    }, [_vm._v("单价")]), _c('Col', {
      staticClass: "price-heade",
      attrs: {
        "span": "4"
      }
    }, [_vm._v("价格")]), _c('Col', {
      staticClass: "UoD-heade",
      attrs: {
        "span": "4"
      }
    }, [_vm._v("涨跌")])], 1), item.materialCostDetail ? _c('div', _vm._l(item.materialCostDetail, function (material) {
      return _c('Row', {
        key: material._id,
        staticClass: "material-wrap",
        attrs: {
          "value": material._id
        }
      }, [_c('Col', {
        staticClass: "material-model",
        attrs: {
          "span": "8"
        }
      }, [_vm._v(_vm._s(material.material.model ? material.material.model : material.material.name))]), _c('Col', {
        staticClass: "ratio",
        attrs: {
          "span": "4"
        }
      }, [_vm._v(_vm._s((material.ratio * 100).toFixed(2) + "%"))]), _c('Col', {
        staticClass: "ratio",
        attrs: {
          "span": "4"
        }
      }, [_vm._v(_vm._s(parseInt(material.calcUnitCost)))]), _c('Col', {
        staticClass: "price",
        attrs: {
          "span": "4"
        }
      }, [_vm._v(_vm._s(parseInt(material.materialCost)))]), _c('Col', {
        staticClass: "UoD",
        style: _vm.materialDiffStyle(material.material.diff),
        attrs: {
          "span": "4"
        }
      }, [_vm._v(_vm._s(material.material.diff))])], 1);
    }), 1) : _c('div', [_vm._v("暂无配方数据...")]), _c('Row', {
      staticClass: "total-wrap"
    }, [_c('Col', {
      staticClass: "total-key",
      attrs: {
        "span": "8"
      }
    }, [_vm._v("合计")]), _c('Col', {
      staticClass: "total-ratio",
      attrs: {
        "span": "3"
      }
    }, [_vm._v("100%")]), _c('Col', {
      staticClass: "total-price",
      attrs: {
        "span": "7"
      }
    }, [_vm._v(_vm._s(parseInt(item.materialCost)))]), _c('Col', {
      staticClass: "total-UoD",
      attrs: {
        "span": "3"
      }
    }, [_vm._v("-")])], 1), _c('div', {
      staticClass: "cost-wrap"
    }, [_c('Row', {
      staticClass: "semiFactory row"
    }, [_c('Col', {
      staticClass: "cost-semiFactory",
      attrs: {
        "span": "17"
      }
    }, [_vm._v("母液工厂")]), _c('Col', {
      staticClass: "cost-value",
      attrs: {
        "span": "7"
      }
    }, [_vm._v(_vm._s(item.factory.name))])], 1), _c('CalcCostInfoRow', {
      attrs: {
        "field": "材料总成本",
        "value": item.materialCost,
        "diffValue": item.diff.materialCost
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "运费",
        "value": item.transCost,
        "diffValue": item.diff.transCost
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "业务费",
        "value": item.promoFee,
        "diffValue": item.diff.promoFee
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "复配费",
        "value": item.manufactCost,
        "diffValue": item.diff.manufactCost
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "税费",
        "value": item.tax,
        "diffValue": item.diff.tax
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "合计成本",
        "value": item.totalCost,
        "diffValue": item.diff.totalCost
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "售价",
        "value": item.price,
        "diffValue": item.diff.price,
        "typeTwo": true
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "利润",
        "value": item.profit,
        "diffValue": item.diff.profit,
        "typeTwo": true
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "利润率",
        "value": item.profitRate,
        "diffValue": item.diff.profitRate,
        "isPercentage": true,
        "typeTwo": true
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "账期（月）",
        "value": item.estAging,
        "diffValue": item.diff.estAging
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "资金成本",
        "value": item.agingCost,
        "diffValue": item.diff.agingCost
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "合计成本（含资）",
        "value": item.totalCostWithAging,
        "diffValue": item.diff.totalCostWithAging
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "利润（含资）",
        "value": item.profitAfterAging,
        "diffValue": item.diff.profitAfterAging,
        "typeTwo": true
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "利润率（含资）",
        "value": item.profitRateAfterAging,
        "diffValue": item.diff.profitRateAfterAging,
        "isPercentage": true,
        "typeTwo": true
      }
    }), _c('CalcCostInfoRow', {
      attrs: {
        "field": "年收益率",
        "value": item.annualizedRateOfReturns,
        "diffValue": item.diff.annualizedRateOfReturns,
        "isPercentage": true,
        "typeTwo": true
      }
    })], 1)], 1)], 1);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }